import React, { Component } from 'react'
// import { FormattedMessage } from 'react-intl'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { get } from 'lodash'

import { Checkbox } from 'components/fields'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { logError, modal } from 'redux/modules/app'
import { apiAwards } from 'helpers/decorators/api'

import { ORGANIZATION_MODES } from 'constants/enums'

const enhance = compose(
  apiAwards({
    updateList: true,
    listReadParams: 'PAYMENT_INFO,LEADER,PARTICIPANT_REGISTRATION'
  }),
  form({
    form: 'change-award-mode'
  }),
  connect(
    ({ api }) => ({
      awardLoading: api.awards.loading
    }),
    {
      logError,
      modal
    }
  )
)

class AwardChangeMode extends Component {
  static propTypes = {
    awardId: PropTypes.number.isRequired,
    currentAwardLevel: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onUpdateAwardMode: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    awardLoading: PropTypes.bool
  }

  static defaultProps = {
    values: {},
    codeLists: {},
    awardId: null
  }

  componentDidMount = () => {
    this.props.initialize({
      awardMode: {
        value: get(this.props, 'awardMode.value') ===
          ORGANIZATION_MODES.offline.id
      }
    })
  }

  render() {
    const {
      awardId,
      currentAwardLevel,
      handleSubmit,
      submitting,
      values,
      awardLoading
    } = this.props

    return (
      <form
        onSubmit={handleSubmit(() =>
          this.props.onUpdateAwardMode(awardId, values, {
            currentAwardLevel
          })
        )}
      >
        <div className="row">
          <div className="col-xs-12">
            <Title
              h2
              intlKey="heading.change_awards_mode"
              className="text--center reset--margin-bottom"
            >
              Change award's mode
            </Title>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Checkbox
              name="awardMode.value"
              label="Participant is semi-offline"
              intlKey="label.participant_is_semi_offline"
              justify
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              onClick={() => this.props.modal(null)}
              secondary
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              intlKey="button.change"
              isLoading={submitting || awardLoading}
            >
              Change
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(AwardChangeMode)
